import {
	SitesQueryParams,
	SiteResponse,
	SingleSiteResponse,
	CreateSiteRequest,
	UpdateSiteRequest,
} from './types';
import { MutationRequest, NoContent, PaginatedResponse, PaginationQueryParams } from '../types';
import { httpClient } from '../http';
import { AdminDeviceResponse } from '../devices/types';

export const getSites = async (
	id: string,
	queryParams?: SitesQueryParams
): Promise<PaginatedResponse<SiteResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<SiteResponse>>(`/customers/${id}/sites`, {
		params: queryParams,
	});

	return data;
};

export const getSite = async (siteId: string): Promise<SingleSiteResponse> => {
	const { data } = await httpClient.get<SingleSiteResponse>(`/sites/${siteId}`);

	return data;
};

export const createSite = async (
	id: string,
	{ request, formKey }: MutationRequest<CreateSiteRequest>
): Promise<SiteResponse> => {
	const { data } = await httpClient.post<SiteResponse>(`/customers/${id}/sites`, request, {
		headers: { formKey },
	});

	return data;
};

export const updateSite = async (
	siteId: string,
	{ request, formKey }: MutationRequest<UpdateSiteRequest>
): Promise<SingleSiteResponse> => {
	const { data } = await httpClient.patch<SingleSiteResponse>(`/sites/${siteId}`, request, {
		headers: { formKey },
	});

	return data;
};

export const deleteSite = async (id: string): Promise<NoContent> => {
	const { data } = await httpClient.delete<NoContent>(`/sites/${id}`);

	return data;
};

export const downloadTemplate = async (siteId: string): Promise<string> => {
	const { data } = await httpClient.get<string>(`/sites/${siteId}/template`, {
		responseType: 'blob',
	});

	return data;
};

export const uploadTemplate = async (siteId: string, formData: FormData): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>(`/sites/${siteId}/upload`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});

	return data;
};

export const getSiteDevices = async (
	siteId: string,
	queryParams: PaginationQueryParams
): Promise<PaginatedResponse<AdminDeviceResponse>> => {
	const { data } = await httpClient.get<PaginatedResponse<AdminDeviceResponse>>(
		`/sites/${siteId}/devices`,
		{ params: queryParams }
	);
	return data;
};

export const exportSiteUsers = async (siteId: string) => {
	const { data } = await httpClient.get<string>(`/sites/${siteId}/users/export`, {
		responseType: 'blob',
	});

	return data;
};
